import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { IIncentiveQuery } from "../../models/incentive/query";
import { IIncentive } from "../../models/incentive/response";
import {
  ICreateIncentive,
  IExportIncentiveExcel,
  IUpdateIncentive,
} from "../../models/incentive/request";
import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

class IncentiveService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllIncentives = (
    query: IIncentiveQuery,
    params?: RequestParams
  ) =>
    this.http.request<IBaseListingResponse<IIncentive>>({
      path: `/incentives`,
      method: "GET",
      query,
      ...params,
    });

  getIncentive = (id: number, params?: RequestParams) =>
    this.http.request<IIncentive>({
      path: `/incentives/${id}`,
      method: "GET",
      ...params,
    });

  createIncentive = (
    data: ICreateIncentive,
    params?: RequestParams
  ) =>
    this.http.request<IIncentive>({
      path: "/incentives",
      method: "POST",
      body: data,
      ...params,
    });

  updateIncentive = (
    id: number,
    data: IUpdateIncentive,
    params?: RequestParams
  ) =>
    this.http.request<IIncentive>({
      path: `/incentives/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteIncentive = (id: number, params?: RequestParams) =>
    this.http.request<IIncentive>({
      path: `/incentives/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (
    data: IExportIncentiveExcel,
    query: IIncentiveQuery
  ) =>
    axios.post(
      `${process.env.REACT_APP_BASE_API_URL}/incentives/export`,
      data,
      {
        headers: {
          authorization: `Bearer ${
            localStorage.getItem(ACCESS_TOKEN) ||
            sessionStorage.getItem(ACCESS_TOKEN)
          }`,
          "Content-Type": "application/json",
          "accept-language": `${
            localStorage.getItem(LANGUAGE_CODE) ??
            process.env.REACT_APP_DEFAULT_LANGUAGE
          }`,
        },
        params: query,
        responseType: "arraybuffer",
      }
    );
}

export default IncentiveService;
